import { Filter, OrderDirection } from '../../../equipment/devices/components/devices.models';
import { FilterModel } from '../../../../shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { RequestStatusState, initialRequestStatusState } from '@portal/shared/store/request-status';
import {
  DcuMtuCommunicationCountsResponse,
  DcuMtuCommunicationPayload,
  DcuToMtuCommunicationFilterName,
  DcuToMtuCommunicationMeasuringPeriodValue,
  DcuToMtuCommunicationTable
} from '../dcu-to-mtu-communication.types';
import { SearchType } from '@ui/aos-lib';
import {
  DATE_RANGE_FILTER,
  DCU_COVERAGE_FILTER,
  dcuMtuCommunicationSortFiled,
  DEFAULT_DCU_TO_MTU_COMMUNICATION_SEARCH_TYPES,
  RELIABILITY_FILTER,
  REPORT_GROUP_FILTER
} from '../dcu-to-mtu-communication.constants';

export interface DcuMtuCommunicationState {
  payload: DcuMtuCommunicationPayload;
  tableData: DcuToMtuCommunicationTable;
  statistics: DcuMtuCommunicationCountsResponse;
  tableDataRequest: RequestStatusState;
  statisticsRequest: RequestStatusState;
  filtersRequest: RequestStatusState;
  exportRequest: RequestStatusState;
  isResetButtonVisible: boolean;
  dcuCoverageFilter: FilterModel;
  dateRangeFilter: FilterModel;
  reliabilityFilter: FilterModel;
  reportGroupFilter: FilterModel;
  search: SearchType;
  searchTypeChanged: boolean;
}

export const initialFilters: Filter[] = [
  {
    filterType: DcuToMtuCommunicationFilterName.DateRange,
    filteredValues: [DcuToMtuCommunicationMeasuringPeriodValue.LAST_7_DAYS]
  }
];

export const initialState: DcuMtuCommunicationState = {
  payload: {
    filters: initialFilters,
    take: 50,
    skip: 0,
    sort: {
      columnName: dcuMtuCommunicationSortFiled.mtuId,
      orderDirection: OrderDirection.DESC
    }
  },
  search: DEFAULT_DCU_TO_MTU_COMMUNICATION_SEARCH_TYPES,
  tableData: { data: [], total: 0 },
  statistics: {
    average: 0,
    counts: []
  },
  tableDataRequest: initialRequestStatusState,
  statisticsRequest: initialRequestStatusState,
  filtersRequest: initialRequestStatusState,
  exportRequest: initialRequestStatusState,
  isResetButtonVisible: false,
  dcuCoverageFilter: DCU_COVERAGE_FILTER,
  dateRangeFilter: DATE_RANGE_FILTER,
  reliabilityFilter: RELIABILITY_FILTER,
  reportGroupFilter: REPORT_GROUP_FILTER,
  searchTypeChanged: false
};
